import Immutable from 'seamless-immutable';
import { createReducer } from 'redux-act';

import ResetPasswordPanelActions from './actions';

const initialState = Immutable({
  userId:        '',
  userEmail:     '',
  isSupportUser: false,

  avatar:     '',
  password:   '',
  repassword: '',
});

export default createReducer(on => {
  on(ResetPasswordPanelActions.bootstrap, (state, { userId, userEmail, isSupportUser }) => {
    return state
      .set('userId', userId)
      .set('userEmail', userEmail)
      .set('isSupportUser', isSupportUser);
  });

  on(ResetPasswordPanelActions.updateField, (state, { fieldId, value }) => {
    return state.set(fieldId, value);
  });
}, initialState);
